// generated by genversion
module.exports = '0.0.1';



//////////////////
// WEBPACK FOOTER
// ./src/utils/version.js
// module id = 636
// module chunks = 0